module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-level"
  }, [_c('h1', [_vm._v("Hot Stove")]), _c('div', {
    staticClass: "embed-grid"
  }, [_vm._m(0), _vm._m(1), _vm._m(2), _c('div', {
    staticClass: "embedded"
  }, [_c('youtube', {
    attrs: {
      "video-id": 'W-Q671j1MO4',
      "player-width": "384",
      "player-height": "240"
    }
  }), _vm._m(3)], 1), _c('div', {
    staticClass: "embedded"
  }, [_c('tweet-embed', {
    attrs: {
      "id": '882186896285282304'
    }
  }), _vm._m(4)], 1), _c('div', {
    staticClass: "embedded"
  }, [_c('tweet-embed', {
    attrs: {
      "id": '883829926993862656'
    }
  }), _vm._m(5)], 1), _c('div', {
    staticClass: "embedded"
  }, [_c('youtube', {
    attrs: {
      "video-id": 'UucY6LmTkrI',
      "player-width": "384",
      "player-height": "240"
    }
  }), _vm._m(6)], 1), _c('div', {
    staticClass: "embedded"
  }, [_c('youtube', {
    attrs: {
      "video-id": 'FVFdsl29s_Q',
      "player-width": "384",
      "player-height": "240"
    }
  }), _vm._m(7)], 1), _c('div', {
    staticClass: "embedded"
  }, [_c('youtube', {
    attrs: {
      "video-id": '4497ZM_d3cs',
      "player-width": "384",
      "player-height": "240"
    }
  }), _vm._m(8)], 1), _c('div', {
    staticClass: "embedded"
  }, [_c('youtube', {
    attrs: {
      "video-id": 'RnfYF_RTEc0',
      "player-width": "384",
      "player-height": "240"
    }
  }), _vm._m(9)], 1), _c('div', {
    staticClass: "embedded"
  }, [_c('tweet-embed', {
    attrs: {
      "id": '864631567972540417'
    }
  }), _vm._m(10)], 1), _c('div', {
    staticClass: "embedded"
  }, [_c('tweet-embed', {
    attrs: {
      "id": '474134260149157888'
    }
  }), _vm._m(11)], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "embedded"
  }, [_c('img', {
    staticClass: "pic",
    attrs: {
      "src": "/static/RLAuOZT.gif"
    }
  }), _c('p', [_c('small', [_vm._v("TTTTrump's America")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "embedded"
  }, [_c('img', {
    staticClass: "pic",
    attrs: {
      "src": "/static/usa-trump-giant-rat.jpg"
    }
  }), _c('p', [_c('small', [_vm._v("NYC Welcome Home")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "embedded"
  }, [_c('img', {
    staticClass: "pic",
    attrs: {
      "src": "/static/hair.jpg"
    }
  }), _c('p', [_c('small', [_vm._v("Hairswap")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('small', [_vm._v("MOOOOOCH")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('small', [_vm._v("WTF is this?! Sounds Hitlertastic")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('small', [_vm._v("This is the best burn to date. Austrailia with a reality check.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('small', [_vm._v("Bernie Busting Budgets")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('small', [_vm._v("Great summary of this insane Presidency")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('small', [_vm._v("WH built on lies, caving in.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('small', [_vm._v("Strong marriage they've got there..")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('small', [_vm._v("Turkish strongmen attack protestors in Washington, DC")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('small', [_vm._v("Hypocritical")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d6e29c3e"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HotStove.vue
// module id = 1086
// module chunks = 1